import { useDeleteSusMutation } from '@/features/api/endpoints/suEndpoints';
import { useIsXs } from '@/shared/utils/mediaQuery-utils';
import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { useTranslate } from '@tolgee/react';

/** Renvoie une fonction qui demande confirmation puis supprime les SU donnés. */
const useConfirmDeleteSus = () => {
  const { t } = useTranslate();
  const isXs = useIsXs();
  const [deleteSus] = useDeleteSusMutation();

  return (ids: number[], onDeleted?: () => void) => {
    const count = ids.length;
    modals.openConfirmModal({
      title: t('admin.sus.delete.confirm.title'),
      fullScreen: isXs,
      centered: true,
      children: <Text size="sm">{t('admin.sus.delete.confirm.message', { count })}</Text>,
      labels: { cancel: t('common.cancel'), confirm: t('common.delete') },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        try {
          await deleteSus(ids).unwrap();
          onDeleted?.();
          notifications.show({ color: 'green', message: t('admin.sus.delete.success', { count }) });
        } catch {
          notifications.show({ color: 'red', message: t('admin.sus.delete.error') });
        }
      },
    });
  };
};

export default useConfirmDeleteSus;
